









































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class ModelLeftNav extends Vue {
  @Prop()
  private cState: any;
  private get user() {
    return this.$store.state.user;
  }
  /**
   * @description 跳转
   */
  private jump(target) {
    switch (target) {
      case "我的模型":
        this.$router.push("/main/model/my-model");
        break;
      case "创建模型":
        this.$router.push("/main/model/create-model");
        break;
      case "模型训练":
        this.$router.push("/main/model/model-train");
        break;
      case "模型试用":
        this.$router.push("/main/model/model-trial");
        break;
    }
  }
}
